export const themeOptions = [
  'insurance',
  'marketplace',
  'personalFinance',
  'rental',
];
export const themeOptionsOptional = ['', ...themeOptions];
export const phonePositions = ['left', 'center', 'right'];
